import React, { createContext, useContext, useMemo, useState } from 'react';
import { modalState } from '../../constants/consts';
const initialData = {
  isContactFormOpen: false,
  contactFormType: null,
  displayVideoModal: { STATE: modalState.CLOSE, VIEW: null },
  productionMedia: null,
  isVideoGalleryDialog: false,
  chosenVideoIndex: 0,
  videoList: [],
  updatedSubTitle: '',
  displayRedirectionPopup: false,
  redirectionPopupMedia: null,
  isLoginDialog: false,
  productionDetails: null,
  isRegistrationDialog: { isOpen: false, isRedirect: false },
  giftRegistrationData: {},
  isHelpInfoModal: false,
  helpInfoData: {},
};
export const DialogsContext = createContext(initialData);
const DialogsProvider = props => {
  const [isLoginDialog, setIsLoginDialog] = useState(initialData.isLoginDialog);
  const [displayVideoModal, setDisplayVideoModal] = useState(initialData.displayVideoModal);
  const [productionMedia, setProductionMedia] = useState(initialData.productionMedia);
  const [isVideoGalleryDialog, setVideoGalleryDialog] = useState(initialData.productionMedia);
  const [chosenVideoIndex, setChosenVideoIndex] = useState(initialData.chosenVideoIndex);
  const [videoList, setVideoList] = useState(initialData.videoList);
  const [updatedSubTitle, setUpdatedSubTitle] = useState(initialData.updatedSubTitle);
  const [productionDetails, setProductionDetails] = useState(initialData.updatedSubTitle);
  const [displayRedirectionPopup, setDisplayRedirectionPopup] = useState(initialData.displayRedirectionPopup);
  const [redirectionPopupMedia, setRedirectionPopupMedia] = useState(initialData.redirectionPopupMedia);
  const [isRegistrationDialog, setRegistrationDialog] = useState(initialData.isRegistrationDialog);
  const [giftRegistrationData, setGiftRegistrationData] = useState(initialData.giftRegistrationData);
  const [isHelpInfoModal, setIsHelpInfoModal] = useState(initialData.isHelpInfoModal);
  const [helpInfoData, setHelpInfoData] = useState(initialData.helpInfoData);

  const openVideoGalleryDialog = (index, videoSet, subTitle) => {
    setVideoList(videoSet);
    setUpdatedSubTitle(subTitle);
    setChosenVideoIndex(index);
    setVideoGalleryDialog(true);
  };
  const resetDialogState = () => {
    setIsLoginDialog(initialData.isLoginDialog);
    setDisplayVideoModal(initialData.displayVideoModal);
    setProductionMedia(initialData.productionMedia);
    setVideoGalleryDialog(initialData.productionMedia);
    setChosenVideoIndex(initialData.chosenVideoIndex);
    setVideoList(initialData.videoList);
    setUpdatedSubTitle(initialData.updatedSubTitle);
    setProductionDetails(initialData.updatedSubTitle);
    setDisplayRedirectionPopup(initialData.displayRedirectionPopup);
    setRedirectionPopupMedia(initialData.redirectionPopupMedia);
  };

  const openHelpModal = (helpUrl, knowledgeBaseLink) => {
    setHelpInfoData({ helpUrl, knowledgeBaseLink });
    setIsHelpInfoModal(true);
  };

  const dataValue = useMemo(
    () => ({
      displayVideoModal,
      setDisplayVideoModal,
      productionMedia,
      setProductionMedia,
      isVideoGalleryDialog,
      setVideoGalleryDialog,
      chosenVideoIndex,
      setChosenVideoIndex,
      videoList,
      setVideoList,
      updatedSubTitle,
      setUpdatedSubTitle,
      openVideoGalleryDialog,
      displayRedirectionPopup,
      setDisplayRedirectionPopup,
      redirectionPopupMedia,
      setRedirectionPopupMedia,
      productionDetails,
      setProductionDetails,
      isLoginDialog,
      setIsLoginDialog,
      resetDialogState,
      isRegistrationDialog,
      setRegistrationDialog,
      giftRegistrationData,
      setGiftRegistrationData,
      isHelpInfoModal,
      setIsHelpInfoModal,
      helpInfoData,
      openHelpModal,
    }),
    [
      displayVideoModal,
      productionMedia,
      isVideoGalleryDialog,
      chosenVideoIndex,
      videoList,
      updatedSubTitle,
      displayRedirectionPopup,
      redirectionPopupMedia,
      isLoginDialog,
      productionDetails,
      isRegistrationDialog,
      giftRegistrationData,
      isHelpInfoModal,
      helpInfoData,
    ],
  );
  return <DialogsContext.Provider value={dataValue} {...props} />;
};
export const useDialogs = () => useContext(DialogsContext);
export default DialogsProvider;
